import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MappingComponent } from '../../mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-new-area',
    templateUrl: './new-area.component.html',
    styleUrls: ['./new-area.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewAreaComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<MappingComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) {
    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close({"option": "cancel"});
    });
   }

  ngOnInit(): void {
  }

  addArea() {
    this.dialogRef.close({"option": "add"});
  }

  editArea() {
    this.dialogRef.close({"option": "edit"});
  }

  redraw() {
    this.dialogRef.close({"option": "redraw"});
  }

}
